export const facebookDefaultCountryMap = {
  en: 'en_US',
  es: 'es_MX',
  fr: 'fr_CA',
} as const;
